import React from "react";
import { Link } from "react-router-dom";
import Style from "../Style/Header.module.scss";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Header = ({ darkMode }) => {
  return (
    <div className={`${Style.header} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.wrapper}>
        <div className={Style.HeaderFlex}>
          <div className={Style.headleft}>
            <span>
              <FaEnvelope className={Style.icon} />{" "}
              sinhalearningsolutions@gmail.com
            </span>
            <span>
              <FaPhoneAlt className={Style.icon} /> 7506050108 | 9051193920
            </span>
          </div>
          <div className={Style.headright}>
            <Link to="/user-login">Login</Link>
            <Link to="/user-register">Register</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
